import {PiShieldPlusBold, LuFastForward, LuCode, LuCircleDollarSign, LuRuler, FiAirplay, FiHeart,TfiLayersAlt, BiBullseye,TbAward, PiNotebook, LuUser2, RxRulerSquare,FiWifi, LuUsers2,MdCropRotate,LuGlassWater, LuParkingCircle, LuWebhook, GrDatabase, TbFidgetSpinner,LuServerCog,TbCloudDownload, FiServer,PiBrowsersBold, LuTag, LuPencil, BiBriefcaseAlt2, FaRegChartBar, FiVolume2, LuUserCheck2, LuDollarSign, LuPizza, LiaBookReaderSolid, BiClinic } from '../assets/icons/vander'

import client1 from '../assets/images/client/01.jpg'
import client2 from '../assets/images/client/02.jpg'
import client3 from '../assets/images/client/03.jpg'
import client4 from '../assets/images/client/04.jpg'
import client5 from '../assets/images/client/05.jpg'
import client6 from '../assets/images/client/06.jpg'
import client7 from '../assets/images/client/07.jpg'
import client8 from '../assets/images/client/08.jpg'

import finance1 from '../assets/images/illustrator/1.svg'
import finance2 from '../assets/images/illustrator/2.svg'
import finance3 from '../assets/images/illustrator/3.svg'

import event1 from '../assets/images/studio/13.jpg'
import event2 from '../assets/images/studio/14.jpg'
import event3 from '../assets/images/studio/15.jpg'
import event4 from '../assets/images/studio/16.jpg'

import blog1 from '../assets/images/blog/01.jpg'
import blog2 from '../assets/images/blog/02.jpg'
import blog3 from '../assets/images/blog/03.jpg'
import blog4 from '../assets/images/blog/04.jpg'
import blog5 from '../assets/images/blog/05.jpg'
import blog6 from '../assets/images/blog/06.jpg'
import blog7 from '../assets/images/blog/07.jpg'
import blog8 from '../assets/images/blog/08.jpg'

import studio1 from '../assets/images/studio/1.jpg'
import studio2 from '../assets/images/studio/2.jpg'
import studio3 from '../assets/images/studio/3.jpg'
import studio4 from '../assets/images/studio/4.jpg'
import studio5 from '../assets/images/studio/5.jpg'
import studio6 from '../assets/images/studio/6.jpg'
import studio7 from '../assets/images/studio/7.jpg'
import studio8 from '../assets/images/studio/8.jpg'
import studio9 from '../assets/images/studio/9.jpg'
import studio10 from '../assets/images/studio/10.jpg'
import studio11 from '../assets/images/studio/11.jpg'
import studio12 from '../assets/images/studio/12.jpg'

import team1 from '../assets/images/team/06.jpg'
import team2 from '../assets/images/team/03.jpg'
import team3 from '../assets/images/team/02.jpg'
import team4 from '../assets/images/team/04.jpg'

import contraction1 from '../assets/images/contraction/02.jpg'
import contraction2 from '../assets/images/contraction/03.jpg'
import contraction3 from '../assets/images/contraction/04.jpg'
import contraction4 from '../assets/images/contraction/05.jpg'

import property1 from '../assets/images/property/01.jpg'
import property2 from '../assets/images/property/02.jpg'
import property3 from '../assets/images/property/03.jpg'
import property4 from '../assets/images/property/04.jpg'
import property5 from '../assets/images/property/05.jpg'
import property6 from '../assets/images/property/06.jpg'

import charity1 from '../assets/images/charity/cause03.jpg'
import charity2 from '../assets/images/charity/cause04.jpg'
import charity3 from '../assets/images/charity/cause06.jpg'

import contact1 from '../assets/images/contact/london.jpg'
import contact2 from '../assets/images/contact/newyork.jpg'
import contact3 from '../assets/images/contact/paris.jpg'

export const appFeature = [
    {
        icon:PiShieldPlusBold,
        title:'Safe & Secure',
        desc:"If the distribution of letters and 'words' is random, the reader will not be distracted."
    },
    {
        icon:LuFastForward,
        title:'Quick & Easy',
        desc:"The most well-known dummy text is the 'Lorem', which is said to have in."
    },
    {
        icon:LuCode,
        title:'Trusted',
        desc:"One disadvantage of Lorum Ipsum is that in certain letters appear more than."
    },
    {
        icon:LuCircleDollarSign,
        title:'Low Cost',
        desc:"Moreover, in Latin only words at the beginning of sentences are capitalized."
    },
]

export const gymCounter = [
    {
        title:'Happy Customer',
        value:'1000'
    },
    {
        title:'Expert Trainer',
        value:'500'
    },
    {
        title:'Cup Of Coffee',
        value:'999'
    },
]

export const gymServices = [
    {
        icon:'mdi mdi-dumbbell',
        title:'Chest Workout',
        desc:"The most well-known dummy text is the 'Lorem', which well-known is said which is said to have in."
    },
    {
        icon:'mdi mdi-kettlebell' ,
        title:'Muscle Workout',
        desc:"One disadvantage of Lorum Ipsum is that in certain letters which is said appear more than."
    },
    {
        icon:'mdi mdi-weight-lifter',
        title:'Lag Workout',
        desc:"Moreover, in Latin only words at the beginning of sentences which is said are capitalized."
    },
    {
        icon:'mdi mdi-run-fast',
        title:'Running',
        desc:"If the fill text is intended to illustrate the characteristics well-known which is said of sometimes."
    },
    {
        icon:'mdi mdi-jump-rope',
        title:'Stretching',
        desc:"There is now an abundance of readable dummy texts. These are which well-known is said text is."
    },
    {
        icon:'mdi mdi-trophy-outline' ,
        title:'Winning Trophy',
        desc:"These alternatives to the classic are often amusing and tell short, which is said stories."
    },
]
export const businessProgress = [
    {
        title:'Assets',
        value:'84%',
        color:'bg-primary'
    },
    {
        title:'Liabilities',
        value:'75%',
        color:'bg-danger'
    },
    {
        title:'Investment',
        value:'79%',
        color:'bg-info'
    },
    {
        title:'Profit',
        value:'95%',
        color:'bg-success'
    },
]

export const businessFeature = [
    {
        icon:'mdi mdi-monitor-cellphone text-info mdi-36px',
        title:'Multiple Layouts',
        desc:'It seems that only fragments of the original text remain in the Lorem Ipsum texts used today.'
    },
    {
        icon:'mdi mdi-heart-outline text-danger mdi-36px',
        title:'Modular Components',
        desc:'It seems that only fragments of the original text remain in the Lorem Ipsum texts used today.'
    },
    {
        icon:'mdi mdi-star-outline text-warning mdi-36px',
        title:'Fully Responsive',
        desc:'It seems that only fragments of the original text remain in the Lorem Ipsum texts used today.'
    },
]

export const teamTwoData = [
    {
        image:client1,
        name:'Lisa Martin',
        position:'Founder',
        social:['mdi mdi-facebook','mdi mdi-instagram','mdi mdi-twitter','mdi mdi-google-plus','mdi mdi-linkedin']
    },
    {
        image:client2,
        name:'Calvin Carlo',
        position:'C.E.O.',
        social:['mdi mdi-facebook','mdi mdi-instagram','mdi mdi-twitter','mdi mdi-google-plus','mdi mdi-linkedin']
    },
    {
        image:client3,
        name:'Richha Jotchi',
        position:'Manager',
        social:['mdi mdi-facebook','mdi mdi-instagram','mdi mdi-twitter','mdi mdi-google-plus','mdi mdi-linkedin']
    },
    {
        image:client4,
        name:'Cristino Murfy',
        position:'Accountant',
        social:['mdi mdi-facebook','mdi mdi-instagram','mdi mdi-twitter','mdi mdi-google-plus','mdi mdi-linkedin']
    },
]

export const financefeature = [
    {
        image:finance1,
        title:'Flexible solutions',
        desc:'It seems that only fragments of the original text remain in the fragments Lorem Ipsum texts used today.'
    },
    {
        image:finance2,
        title:'Team Work',
        desc:'It seems that only fragments of the original text remain in the fragments Lorem Ipsum texts used today.'
    },
    {
        image:finance3,
        title:'Best Pricing',
        desc:'It seems that only fragments of the original text remain in the fragments Lorem Ipsum texts used today.'
    },
]

export const marketingFeature = [
    {
        icon:LuRuler,
        title:'Stylish Design',
        desc:"If the distribution of letters and 'words' distribution is random, the reader will not be distracted."
    },
    {
        icon:FiAirplay,
        title:'Fresh Layouts',
        desc:"The most well-known dummy text is the 'Lorem', distribution letters which is said to have in."
    },
    {
        icon:FiHeart,
        title:'Fully Responsive',
        desc:"One disadvantage of Lorum Ipsum is that in certain distribution letters letters appear more than."
    },
]

export const eventData = [
    {
        id:1,
        image:event1,
        desc:"This is required when, for example, the final text is not yet available. Dummy text is also known as 'fill text'. It is said that song composers of the past used dummy texts as lyrics."
    },
    {
        id:2,
        image:event2,
        desc:"This is required when, for example, the final text is not yet available. Dummy text is also known as 'fill text'. It is said that song composers of the past used dummy texts as lyrics."
    },
    {
        id:3,
        image:event3,
        desc:"This is required when, for example, the final text is not yet available. Dummy text is also known as 'fill text'. It is said that song composers of the past used dummy texts as lyrics."
    },
    {
        id:4,
        image:event4,
        desc:"This is required when, for example, the final text is not yet available. Dummy text is also known as 'fill text'. It is said that song composers of the past used dummy texts as lyrics."
    },
]

export const portfolioServices = [
    {
        icon:LuRuler,
        title:'Stylish Design',
        desc:"If the distribution of letters and 'words' is random, the reader will not be distracted."
    },
    {
        icon:TfiLayersAlt,
        title:'Fresh Layouts',
        desc:"If the distribution of letters and 'words' is random, the reader will not be distracted."
    },
    {
        icon:FiAirplay,
        title:'Fully Responsive',
        desc:"If the distribution of letters and 'words' is random, the reader will not be distracted."
    },
    {
        icon:BiBullseye,
        title:'Modern Workflow',
        desc:"If the distribution of letters and 'words' is random, the reader will not be distracted."
    },
]
export const portfolioData = [
    {
        id:1,
        image:blog1,
        title:'Shifting Perspective',
        name:'Studio',
        category:'branding'
    },
    {
        id:2,
        image:blog2,
        title:'Colors Magazine',
        name:'Web Design',
        category:'designing'
    },
    {
        id:3,
        image:blog3,
        title:'Spa Cosmetics',
        name:'Developing',
        category:'photography'
    },
    {
        id:4,
        image:blog4,
        title:'Riser Coffee',
        name:'Branding',
        category:'development'
    },
    {
        id:5,
        image:blog5,
        title:'Dancing With Myself',
        name:'Photography',
        category:'branding'
    },
    {
        id:6,
        image:blog6,
        title:'New trends in SEO',
        name:'Business',
        category:'designing'
    },
    {
        id:7,
        image:blog7,
        title:'Riser Coffee',
        name:'Branding',
        category:'photography'
    },
    {
        id:8,
        image:blog8,
        title:'Dancing With Myself',
        name:'Photography',
        category:'development'
    },
]
export const portfolioImges = [blog1,blog2,blog3,blog4, blog5, blog6, blog7, blog8]

export const studioImg = [
    studio1,studio8,studio2,studio7,studio3,studio10,studio4,studio9,studio5,studio12,studio6,studio11,
]

export const lawyerServices = [
    {
        icon:TbAward,
        title:'India Evaluation',
        desc:"For businesses assessing if and how India fits their global strategy.",
        linkto:"/page-india-evaluation",
        color:'text-warning h1'
    },
    {
        icon:PiNotebook,
        title:'India Entry',
        desc:"For those ready to establish a legal and operational presence in India.",
        linkto:"/page-india-entry",
        color:'text-info h1'
    },
    {
        icon:LuUser2,
        title:'India Growth',
        desc:"For companies already operating in India but needing to scale, fix, or streamline.",
        linkto:"/page-india-growth",
        color:'text-danger h1'
    },
]
export const lawyerCounter = [
    {
        icon:'mdi mdi-account',
        title:'Clients',
        value:'760'
    },
    {
        icon:'mdi mdi-scale-balance',
        title:'Cases Solved',
        value:'999'
    },
    {
        icon:'mdi mdi-bank',
        title:'Experience',
        value:'100'
    },
    {
        icon:'mdi mdi-gavel',
        title:'Case Dismissed',
        value:'100'
    },
]

export const lawyerTeam = [
    {
        image:team1,
        name:'Martin Dongre',
        position:'Consultant',
        desc:'I must explain to you how all this mistaken idea of denouncing pleasure and system.',
        class:'content float-start p-4',
        imgClass:'img-fluid float-end',
        social:['mdi mdi-facebook','mdi mdi-instagram','mdi mdi-twitter','mdi mdi-google-plus','mdi mdi-linkedin']
    },
    {
        image:team2,
        name:'Lisa Marvel',
        position:'Business Lawyer',
        desc:'I must explain to you how all this mistaken idea of denouncing pleasure and system.',
        class:'content float-start p-4',
        imgClass:'img-fluid float-end',
        social:['mdi mdi-facebook','mdi mdi-instagram','mdi mdi-twitter','mdi mdi-google-plus','mdi mdi-linkedin']
    },
    {
        image:team3,
        name:'Darothy Jane',
        position:'Family Lawyer',
        desc:'I must explain to you how all this mistaken idea of denouncing pleasure and system.',
        class:'content float-end p-4',
        imgClass:'img-fluid float-start',
        social:['mdi mdi-facebook','mdi mdi-instagram','mdi mdi-twitter','mdi mdi-google-plus','mdi mdi-linkedin']
    },
    {
        image:team4,
        name:'Davide Harry',
        position:'Criminal lawyer',
        desc:'I must explain to you how all this mistaken idea of denouncing pleasure and system.',
        class:'content float-end p-4',
        imgClass:'img-fluid float-start',
        social:['mdi mdi-facebook','mdi mdi-instagram','mdi mdi-twitter','mdi mdi-google-plus','mdi mdi-linkedin']
    },
]
export const lawyerCate = [
    {
        icon:'mdi mdi-briefcase-variant-outline',
        title:'Business Law',
        desc:"The most well-known dummy text is the 'Lorem', which well-known is said which is said to have in."
    },
    {
        icon:'mdi mdi-chart-bar',
        title:'Finance Law',
        desc:"One disadvantage of Lorum Ipsum is that in certain letters which is said appear more than."
    },
    {
        icon:'mdi mdi-handcuffs',
        title:'Criminal Law',
        desc:"Moreover, in Latin only words at the beginning of sentences which is said are capitalized."
    },
    {
        icon:'mdi mdi-car-estate',
        title:'Vehicle Law',
        desc:"If the fill text is intended to illustrate the characteristics well-known which is said of sometimes."
    },
    {
        icon:'mdi mdi-cash-100',
        title:'Tax Law',
        desc:"There is now an abundance of readable dummy texts. These are which well-known is said text is."
    },
    {
        icon:'mdi mdi-heart-broken',
        title:'Devorce Law',
        desc:"These alternatives to the classic are often amusing and tell short, which is said stories."
    },
]

export const pricingThreeData = [
    {
        title:'Basic',
        value:'200',
        time:'per person per Month',
        feature:[
            'egant, Distraction Free Cabins',
            '24/7 Access (Unlimited)',
            'Access to all Facilities',
            'Internet-Leased Line',
            '100% Mobile Connectivity',
            'Biometric Access',
            'Hot & Cold Beverages, Mineral Water',
            'Conference Room & Event Spaces'
        ]
    },
    {
        title:'Standard',
        value:'50',
        time:'per Hour',
        feature:[
            'egant, Distraction Free Cabins',
            '24/7 Access (Unlimited)',
            'Access to all Facilities',
            'Internet-Leased Line',
            '100% Mobile Connectivity',
            'Biometric Access',
            'Hot & Cold Beverages, Mineral Water',
            'Conference Room & Event Spaces'
        ]
    },
    {
        title:'Premium',
        value:'150',
        time:'per Month',
        feature:[
            'egant, Distraction Free Cabins',
            '24/7 Access (Unlimited)',
            'Access to all Facilities',
            'Internet-Leased Line',
            '100% Mobile Connectivity',
            'Biometric Access',
            'Hot & Cold Beverages, Mineral Water',
            'Conference Room & Event Spaces'
        ]
    },
]
export const contractionFeature = [
    {
        icon:LuRuler,
        title:'Stylish Design',
        desc:"If the distribution of letters and 'words' is random, the reader will not be distracted."
    },
    {
        icon:FiAirplay,
        title:'Fully Responsive',
        desc:"One disadvantage of Lorum Ipsum is that in certain letters appear more than."
    },
    {
        icon:RxRulerSquare,
        title:'Modern Workflow',
        desc:"Moreover, in Latin only words at the beginning of sentences are capitalized."
    },
    {
        icon:LuUser2,
        title:'Customer Care',
        desc:"There is now an abundance of readable dummy texts. These are text is."
    },
]

export const contractionImage = [
    contraction1,contraction2,contraction3,contraction4
]

export const coworkServices = [
    {
        icon:FiWifi,
        title:'Free Internet',
        desc:"If the distribution of letters and 'words' is random, the reader will not be distracted from making."
    },
    {
        icon:LuUsers2,
        title:'Group Events',
        desc:"If the distribution of letters and 'words' is random, the reader will not be distracted from making."
    },
    {
        icon:MdCropRotate,
        title:'Meeting Room',
        desc:"If the distribution of letters and 'words' is random, the reader will not be distracted from making."
    },
    {
        icon:LuGlassWater,
        title:'Coffee & Tea',
        desc:"If the distribution of letters and 'words' is random, the reader will not be distracted from making."
    },
    {
        icon:LuParkingCircle,
        title:'Free Parking',
        desc:"If the distribution of letters and 'words' is random, the reader will not be distracted from making."
    },
    {
        icon:LuWebhook,
        title:'Relax Room',
        desc:"If the distribution of letters and 'words' is random, the reader will not be distracted from making."
    },
]
export const hostingServices = [
    {
        icon:GrDatabase,
        title:'Shared Hosting',
        desc:"The most well-known dummy text is the 'Lorem', which well-known is said which is said to have in."
    },
    {
        icon:TbFidgetSpinner,
        title:'VPS Hosting',
        desc:"One disadvantage of Lorum Ipsum is that in certain letters which is said appear more than."
    },
    {
        icon:LuServerCog,
        title:'Dedicated Hosting',
        desc:"Moreover, in Latin only words at the beginning of sentences which is said are capitalized."
    },
    {
        icon:TbCloudDownload,
        title:'Cloud Hosting',
        desc:"If the fill text is intended to illustrate the characteristics well-known which is said of sometimes."
    },
    {
        icon:FiServer,
        title:'Reseller Hosting',
        desc:"There is now an abundance of readable dummy texts. These are which well-known is said text is."
    },
    {
        icon:PiBrowsersBold,
        title:'Domain Name',
        desc:"These alternatives to the classic are often amusing and tell short, which is said stories."
    },
]
export const hostingPrice = [
    {
        icon:LuTag,
        iconColor:'text-warning',
        title:'Regular',
        Price:'9',
        feature:[
            {
                f1:'10GB',
                f2:' Ram'
            },
            {
                f1:'100GB',
                f2:' RBandwitham'
            },
            {
                f1:'100GB SSD',
                f2:' Storage'
            },
            {
                f1:'3 Domain',
                f2:' Hosted Support'
            },
            {
                f1:'50',
                f2:' Email Account'
            },
            {
                f1:'5',
                f2:' Database'
            },
            {
                f1:'Unlimited ',
                f2:' Traffic'
            },
        ]
    },
    {
        icon:LuPencil,
        iconColor:'text-danger',
        title:'Business',
        Price:'39',
        feature:[
            {
                f1:'10GB',
                f2:' Ram'
            },
            {
                f1:'100GB',
                f2:' RBandwitham'
            },
            {
                f1:'100GB SSD',
                f2:' Storage'
            },
            {
                f1:'3 Domain',
                f2:' Hosted Support'
            },
            {
                f1:'50',
                f2:' Email Account'
            },
            {
                f1:'5',
                f2:' Database'
            },
            {
                f1:'Unlimited ',
                f2:' Traffic'
            },
        ]
    },
    {
        icon:BiBriefcaseAlt2,
        iconColor:'text-info',
        title:'Premium',
        Price:'99',
        feature:[
            {
                f1:'10GB',
                f2:' Ram'
            },
            {
                f1:'100GB',
                f2:' RBandwitham'
            },
            {
                f1:'100GB SSD',
                f2:' Storage'
            },
            {
                f1:'3 Domain',
                f2:' Hosted Support'
            },
            {
                f1:'50',
                f2:' Email Account'
            },
            {
                f1:'5',
                f2:' Database'
            },
            {
                f1:'Unlimited ',
                f2:' Traffic'
            },
        ]
    },
]

export const propertyData = [
    {
        image:property1,
        name:'Park Avanue',
        loction:'New York, US',
        userName:'Mark Degree',
        contact:'+152 534-468-854',
        value:'$ 750'
    },
    {
        image:property2,
        name:'Hundson Tower',
        loction:'Beijing, China',
        userName:'Mark Degree',
        contact:'+152 534-468-854',
        value:'$ 1000'
    },
    {
        image:property3,
        name:'Trade Center',
        loction:'Londan, England',
        userName:'Mark Degree',
        contact:'+152 534-468-854',
        value:'$ 2250'
    },
    {
        image:property4,
        name:'Citicorp Center',
        loction:'Australia',
        userName:'Mark Degree',
        contact:'+152 534-468-854',
        value:'$ 1550'
    },
    {
        image:property5,
        name:'Pan Am Building',
        loction:'Poland',
        userName:'Mark Degree',
        contact:'+152 534-468-854',
        value:'$ 1800'
    },
    {
        image:property6,
        name:'Goldman Sachs',
        loction:'New Zealand',
        userName:'Mark Degree',
        contact:'+152 534-468-854',
        value:'$ 1900'
    },
]

export const educationCategory =[
    {
        icon:LuRuler,
        title1:'Design &',
        title2:'Development',
        desc:"The most well-known dummy text is the 'Lorem', which well-known is said which is said to have in."
    },
    {
        icon:FiAirplay,
        title1:'Digital',
        title2:'Marketing',
        desc:"One disadvantage of Lorum Ipsum is that in certain letters which is said appear more than."
    },
    {
        icon:FaRegChartBar,
        title1:'Business &',
        title2:'Consulting',
        desc:"Moreover, in Latin only words at the beginning of sentences which is said are capitalized."
    },
    {
        icon:FiVolume2,
        title1:'Marketing  &',
        title2:'Communication',
        desc:"If the fill text is intended to illustrate the characteristics well-known which is said of sometimes."
    },
    {
        icon:LuUserCheck2,
        title1:'Self',
        title2:'Development',
        desc:"There is now an abundance of readable dummy texts. These are which well-known is said text is."
    },
    {
        icon:LuDollarSign,
        title1:'Finance &',
        title2:'Management',
        desc:"These alternatives to the classic are often amusing and tell short, which is said stories."
    },
]

export const charityFeature = [
    {
        icon:LuUsers2,
        title:'Human',
        desc:"The most well-known dummy text is the 'Lorem', which well-known is said which is said to have in."
    },
    {
        icon:LuPizza,
        title:'Food',
        desc:"The most well-known dummy text is the 'Lorem', which well-known is said which is said to have in."
    },
    {
        icon:LiaBookReaderSolid,
        title:'Study',
        desc:"The most well-known dummy text is the 'Lorem', which well-known is said which is said to have in."
    },
    {
        icon:BiClinic,
        title:'Medicine',
        desc:"The most well-known dummy text is the 'Lorem', which well-known is said which is said to have in."
    },
]

export const charityData = [
    {
        image:charity1,
        title:'Donate For Food',
        desc:'If you use this site regularly and would like to help keep the site on the Internet',
        per:'25%',
        raised:'$ 20000.0',
        goal:'$ 80000.0'
    },
    {
        image:charity2,
        title:'Food For Orphan',
        desc:'If you use this site regularly and would like to help keep the site on the Internet',
        per:'50%',
        raised:'$ 50000.0',
        goal:'$ 100000.0'
    },
    {
        image:charity3,
        title:'Home For Homeless',
        desc:'If you use this site regularly and would like to help keep the site on the Internet',
        per:'80%',
        raised:'$ 240000.0',
        goal:'$ 300000.0'
    },
]

export const profileConnection = [
    client1,client2,client3,client4,client5,client6,client7,client8
]

export const contactData = [
    {
        image:contact1,
        name:'Seattle',
        location1:'9309 Stone Ave N',
        location2:'Seattle, WA 98103',
        contact:'+1 206-963-1841',
        mail:'info@minminicorp.com'
    },
    {
        image:contact2,
        name:'Chennai',
        location1:'#13, Ground Floor, Chittaranjan Road',
        location2:'Chennai, TN 600018',
        contact:'+91 444 0925800/',
        mail:'reach@pioneerone.in'
    },
]

